import { useUser } from "@/src/OS/Login/State";
import { useEffect } from "react";
import * as Sentry from "@sentry/react-native";
export function useRegisterSentry() {
  const user = useUser();
  useEffect(() => {
    Sentry.setUser({
      id: user.user.sub,
      email: user.user.email,
      currentStoreId: user.currentStoreId,
    });
    Sentry.setTags({
      currentStoreId: user.currentStoreId,
      deviceLastActive: user.deviceClosedAt,
      currentEmployeeId: user.currentEmployeeId,
      isSharedDevice: user.isSharedDevice,
      currentTeamId: user.currentTeamId,
      currentWorkspaceId: user.currentWorkspaceId,
    });
  }, [
    user.user.email,
    user.user.sub,
    user.currentStoreId,
    user.currentEmployeeId,
    user.isSharedDevice,
    user.currentTeamId,
    user.currentWorkspaceId,
    user.deviceClosedAt,
  ]);
}
